import selectAllElements from "../dom/selectAllElements";
import selectSingleElement from "../dom/selectSingleElement";
import {
	BOTTOMS_UP_LETTERS_SELECTOR,
	BOTTOM_LETTERS_INPUT,
	BUBBLE_LETTERS_SELECTOR,
	CHAINSTITCH,
	FONT_SELECT_SELECTOR,
	FORMOSA_LETTER_SELECTOR,
	HOODBLOCK_LETTERS_SELECTOR_NOT_MICROSCRIPT,
	HOODSCRIPT_LETTERS_SELECTOR_NOT_MICROSCRIPT,
	JOURNEY_LETTER_SELECTOR,
	KNITBEANIE_BLOCK_LETTERS_SELECTOR,
	KNITBEANIE_BUBBLE_LETTERS_SELECTOR,
	KNITBEANIE_FORMOSA_LETTERS_SELECTOR,
	KNITBEANIE_JOURNEY_LETTERS_SELECTOR,
	KNITBEANIE_OLDE_LETTERS_SELECTOR,
	KNITBEANIE_SCRIPT_LETTERS_SELECTOR,
	KNIT_BEANIE_TEXT,
	MICRO,
	MICROFORMOSA_LETTER_SELECTOR,
	MICROHOODBLOCK_LETTERS_SELECTOR,
	MICROHOODSCRIPT_LETTERS_SELECTOR,
	MICROKNITBEANIE_BLOCK_LETTERS_SELECTOR,
	MICROKNITBEANIE_FORMOSA_LETTERS_SELECTOR,
	MICROKNITBEANIE_OLDE_LETTERS_SELECTOR,
	MICROKNITBEANIE_SCRIPT_LETTERS_SELECTOR,
	MICRONEUTRA_LETTERS_SELECTOR,
	MICROSCRIPT_TEXT,
	MICROSCRIPT_TEXT_INPUT,
	MICRO_BEANIE_TEXT,
	MICRO_CHECKBOX,
	MULTILINE_TEXT,
	MULTILINE_TEXTAREA,
	NAME_GAME_LETTERS_SELECTOR,
	NEUTRA_LETTERS_SELECTOR,
	OLDE_LETTERS_MICROSCRIPT_OPTION,
	OLDE_LETTERS_SELECTOR,
	OUTLINE_TEXT,
	OUTLINE_WRAPPER_SELECTOR,
	PROSHOP_LETTERS_SELECTOR,
	SCRIPT_TEXT,
	SCRIPT_TEXT_INPUT,
	SECONDARY_LETTERS,
	THREED_LIFT_TEN,
} from "./_selectors";
import { fontClicked } from "./fontClicked";

function fontScriptSelectSetup() {
	const fontSelect = selectAllElements(FONT_SELECT_SELECTOR);
	if (fontSelect) {
		for (const select of fontSelect) {
			select.addEventListener("click", () =>
				fontClicked({
					threeDGridColumn: "2 / 3",
					shouldResetOutline: true,
					hasCurrentColor: true,
				}),
			);
		}
	}

	const microCheckbox = selectSingleElement<HTMLInputElement>(MICRO_CHECKBOX);
	const microCheckboxIsChecked = microCheckbox?.checked;

	// fonts
	const scriptLetters = selectAllElements(HOODSCRIPT_LETTERS_SELECTOR_NOT_MICROSCRIPT);
	const blockLetters = selectAllElements(HOODBLOCK_LETTERS_SELECTOR_NOT_MICROSCRIPT);
	const bubbleScriptLetters = selectAllElements(BUBBLE_LETTERS_SELECTOR);
	const journeyScriptLetters = selectAllElements(JOURNEY_LETTER_SELECTOR);
	const formosaLetters = selectAllElements(FORMOSA_LETTER_SELECTOR);
	const oldeLetters = selectAllElements(OLDE_LETTERS_SELECTOR);
	const nameGame = selectAllElements(NAME_GAME_LETTERS_SELECTOR);
	const bottomsup = selectAllElements(BOTTOMS_UP_LETTERS_SELECTOR);
	const proshop = selectAllElements(PROSHOP_LETTERS_SELECTOR);
	const neutra = selectAllElements(NEUTRA_LETTERS_SELECTOR);
	// const knitBeanieTextActive = selectSingleElement(KNIT_BEANIE_ACTIVE);
	/*
	 * REGULAR FONTS
	 */
	const commonElementsToShowOrHideWithMicro = [
		{
			displayValue: "flex",
			elements: [
				selectSingleElement(MICRO),
				selectSingleElement(MICROSCRIPT_TEXT),
				selectSingleElement(SCRIPT_TEXT),
				selectSingleElement(THREED_LIFT_TEN),
				selectSingleElement(CHAINSTITCH),
				selectSingleElement(NAME_GAME_LETTERS_SELECTOR),
			],
			show: !microCheckboxIsChecked,
		},
		{
			elements: [selectSingleElement(MICROSCRIPT_TEXT)],
			show: !!microCheckboxIsChecked,
		},
		{
			elements: [selectSingleElement(OUTLINE_TEXT), selectSingleElement(OUTLINE_WRAPPER_SELECTOR)],
			show: true,
		},
		{
			elements: [selectSingleElement(MULTILINE_TEXT), selectSingleElement(MULTILINE_TEXTAREA)],
			show: false,
		},
	];

	// SCRIPT
	if (scriptLetters) {
		for (const select of scriptLetters) {
			select.addEventListener("click", () =>
				fontClicked({
					font: "HoodScript",
					inputElementsToReset: [selectSingleElement(MULTILINE_TEXTAREA)],
					elementsToShowOrHide: [...commonElementsToShowOrHideWithMicro],
				}),
			);
		}
	}
	// BLOCK
	if (blockLetters) {
		for (const select of blockLetters) {
			select.addEventListener("click", () =>
				fontClicked({
					font: "Hood-blockletters",
					inputElementsToReset: [selectSingleElement(MULTILINE_TEXTAREA)],
					elementsToShowOrHide: [...commonElementsToShowOrHideWithMicro],
				}),
			);
		}
	}
	// Formosa
	if (formosaLetters) {
		for (const select of formosaLetters) {
			select.addEventListener("click", () =>
				fontClicked({
					font: "Chinesetakeaway",
					inputElementsToReset: [selectSingleElement(MULTILINE_TEXTAREA)],
					elementsToShowOrHide: [...commonElementsToShowOrHideWithMicro],
				}),
			);
		}
	}
	// Olde
	if (oldeLetters) {
		for (const select of oldeLetters) {
			select.addEventListener("click", () =>
				fontClicked({
					font: "Olde-regular-new",
					inputElementsToReset: [selectSingleElement(MULTILINE_TEXTAREA)],
					elementsToShowOrHide: [...commonElementsToShowOrHideWithMicro],
				}),
			);
		}
	}

	if (neutra) {
		for (const select of neutra) {
			select.addEventListener("click", () =>
				fontClicked({
					font: "Neutra",
					inputElementsToReset: [selectSingleElement(MULTILINE_TEXTAREA)],
					elementsToShowOrHide: [
						...commonElementsToShowOrHideWithMicro,
						{
							elements: [
								selectSingleElement(OUTLINE_TEXT),
								selectSingleElement(OUTLINE_TEXT),
								selectSingleElement(OUTLINE_WRAPPER_SELECTOR),
							],
							show: false,
						},
					],
				}),
			);
		}
	}

	const commonElementsToShowOrHideWithoutMicro = [
		{
			displayValue: "flex",
			elements: [
				selectSingleElement(SCRIPT_TEXT),
				selectSingleElement(THREED_LIFT_TEN),
				selectSingleElement(CHAINSTITCH),
				selectSingleElement(NAME_GAME_LETTERS_SELECTOR),
			],
			show: true,
		},
		{
			elements: [selectSingleElement(OUTLINE_TEXT), selectSingleElement(OUTLINE_WRAPPER_SELECTOR)],
			show: true,
		},
		{
			elements: [
				selectSingleElement(MICRO),
				selectSingleElement(MICROSCRIPT_TEXT),
				selectSingleElement(MULTILINE_TEXTAREA),
			],
			show: false,
		},
	];
	// Bubble
	if (bubbleScriptLetters) {
		for (const select of bubbleScriptLetters) {
			select.addEventListener("click", () =>
				fontClicked({
					font: "Coopernouveau",
					threeDGridColumn: "1 / 3",
					inputElementsToReset: [selectSingleElement(MULTILINE_TEXTAREA)],
					elementsToShowOrHide: [...commonElementsToShowOrHideWithoutMicro],
				}),
			);
		}
	}
	// Journey
	if (journeyScriptLetters) {
		for (const select of journeyScriptLetters) {
			select.addEventListener("click", () =>
				fontClicked({
					font: "Thistails-regular",
					threeDGridColumn: "1 / 3",
					inputElementsToReset: [selectSingleElement(MULTILINE_TEXTAREA)],
					elementsToShowOrHide: [...commonElementsToShowOrHideWithoutMicro],
				}),
			);
		}
	}
	// Bottoms up
	if (bottomsup) {
		for (const select of bottomsup) {
			select.addEventListener("click", () =>
				fontClicked({
					font: "Bottomsup",
					disableBottomLetters: true,
					disableSecondaryLetters: true,
					threeDGridColumn: "1 / 3",
					inputElementsToReset: [selectSingleElement(MULTILINE_TEXTAREA)],
					elementsToShowOrHide: [...commonElementsToShowOrHideWithoutMicro],
				}),
			);
		}
	}
	// Proshop
	if (proshop) {
		for (const select of proshop) {
			select.addEventListener("click", () =>
				fontClicked({
					font: "Almamatersolid",
					disableBottomLetters: true,
					disableSecondaryLetters: true,
					threeDGridColumn: "1 / 3",
					inputElementsToReset: [selectSingleElement(MULTILINE_TEXTAREA)],
					elementsToShowOrHide: [...commonElementsToShowOrHideWithoutMicro],
				}),
			);
		}
	}
	// Name Game
	if (nameGame) {
		for (const select of nameGame) {
			select.addEventListener("click", () => {
				fontClicked({
					font: "Helvetica-roman",
					showOutline: false,
					shouldResetOutline: true,
					disableBottomLetters: true,
					disableSecondaryLetters: true,
					inputElementsToReset: [
						selectSingleElement<HTMLInputElement>(SCRIPT_TEXT_INPUT),
						selectSingleElement<HTMLInputElement>(MICROSCRIPT_TEXT_INPUT),
						selectSingleElement<HTMLInputElement>(SECONDARY_LETTERS),
						selectSingleElement<HTMLInputElement>(BOTTOM_LETTERS_INPUT),
					],
					elementsToShowOrHide: [
						{
							elements: [
								selectSingleElement(MULTILINE_TEXT),
								selectSingleElement(MULTILINE_TEXTAREA),
							],
							show: true,
						},
						{
							elements: [
								selectSingleElement(SCRIPT_TEXT),
								selectSingleElement(MICRO),
								selectSingleElement(MICROSCRIPT_TEXT),
								selectSingleElement(THREED_LIFT_TEN),
								selectSingleElement(CHAINSTITCH),

								selectSingleElement(OUTLINE_TEXT),
								selectSingleElement(OUTLINE_WRAPPER_SELECTOR),
							],
							show: false,
						},
					],
				});
			});
		}
	}

	/*
	 * REGULAR MICRO FONTS
	 */
	// micro fonts
	const microHoodBlockLetters = selectAllElements(MICROHOODBLOCK_LETTERS_SELECTOR);
	const microHoodScriptLetters = selectAllElements(MICROHOODSCRIPT_LETTERS_SELECTOR);
	const microFormosaLetters = selectAllElements(MICROFORMOSA_LETTER_SELECTOR);
	const microOldeLetters = selectAllElements(OLDE_LETTERS_MICROSCRIPT_OPTION);
	const microNeutraLetters = selectAllElements(MICRONEUTRA_LETTERS_SELECTOR);

	const commonElementsToShowOrHideWithMicroScript = [
		{
			displayValue: "flex",
			elements: [selectSingleElement(MICRO), selectSingleElement(MICROSCRIPT_TEXT)],
			show: true,
		},
		{
			elements: [
				selectSingleElement(SCRIPT_TEXT),
				selectSingleElement(MULTILINE_TEXT),
				selectSingleElement(OUTLINE_TEXT),
				selectSingleElement(OUTLINE_WRAPPER_SELECTOR),
			],
			show: false,
		},
	];
	const commonElmentsToResetForMicro = [
		selectSingleElement<HTMLInputElement>(SCRIPT_TEXT_INPUT),
		selectSingleElement<HTMLInputElement>(MULTILINE_TEXTAREA),
	];

	if (microHoodBlockLetters) {
		for (const select of microHoodBlockLetters) {
			select.addEventListener("click", () =>
				fontClicked({
					font: "Hood-blockletters",
					disableBottomLetters: true,
					disableSecondaryLetters: true,
					inputElementsToReset: [...commonElmentsToResetForMicro],
					elementsToShowOrHide: [...commonElementsToShowOrHideWithMicroScript],
				}),
			);
		}
	}

	if (microHoodScriptLetters) {
		for (const select of microHoodScriptLetters) {
			select.addEventListener("click", () =>
				fontClicked({
					font: "HoodScript",
					disableBottomLetters: true,
					disableSecondaryLetters: true,
					inputElementsToReset: [...commonElmentsToResetForMicro],
					elementsToShowOrHide: [...commonElementsToShowOrHideWithMicroScript],
				}),
			);
		}
	}

	if (microFormosaLetters) {
		for (const select of microFormosaLetters) {
			select.addEventListener("click", () =>
				fontClicked({
					font: "Chinesetakeaway",
					disableBottomLetters: true,
					disableSecondaryLetters: true,
					inputElementsToReset: [...commonElmentsToResetForMicro],
					elementsToShowOrHide: [...commonElementsToShowOrHideWithMicroScript],
				}),
			);
		}
	}

	if (microOldeLetters) {
		for (const select of microOldeLetters) {
			select.addEventListener("click", () =>
				fontClicked({
					font: "Olde-regular-new",
					disableBottomLetters: true,
					disableSecondaryLetters: true,
					inputElementsToReset: [...commonElmentsToResetForMicro],
					elementsToShowOrHide: [...commonElementsToShowOrHideWithMicroScript],
				}),
			);
		}
	}

	if (microNeutraLetters) {
		for (const select of microNeutraLetters) {
			select.addEventListener("click", () =>
				fontClicked({
					font: "Neutra",
					disableBottomLetters: true,
					disableSecondaryLetters: true,
					inputElementsToReset: [...commonElmentsToResetForMicro],
					elementsToShowOrHide: [...commonElementsToShowOrHideWithMicroScript],
				}),
			);
		}
	}

	/*
	 * KNIT BEANIE FONTS
	 */
	const knitBeanieScriptLetters = selectAllElements(KNITBEANIE_SCRIPT_LETTERS_SELECTOR);
	const knitBeanieBlockLetters = selectAllElements(KNITBEANIE_BLOCK_LETTERS_SELECTOR);
	const knitBeanieBubbleLetters = selectAllElements(KNITBEANIE_BUBBLE_LETTERS_SELECTOR);
	const knitBeanieJourneyLetters = selectAllElements(KNITBEANIE_JOURNEY_LETTERS_SELECTOR);
	const knitBeanieFormosaLetters = selectAllElements(KNITBEANIE_FORMOSA_LETTERS_SELECTOR);
	const knitBeanieOldeLetters = selectAllElements(KNITBEANIE_OLDE_LETTERS_SELECTOR);

	const commonElementsToShowOrHideForKnitBeanie = [
		{
			displayValue: "flex",
			elements: [selectSingleElement(KNIT_BEANIE_TEXT)],
			show: true,
		},
		{
			elements: [
				selectSingleElement(SCRIPT_TEXT),
				selectSingleElement(MULTILINE_TEXT),
				selectSingleElement(OUTLINE_TEXT),
				selectSingleElement(OUTLINE_WRAPPER_SELECTOR),
			],
			show: false,
		},
	];

	const commonResetForBeanie = [
		selectSingleElement<HTMLInputElement>(SCRIPT_TEXT_INPUT),
		selectSingleElement<HTMLInputElement>(MICROSCRIPT_TEXT_INPUT),
		selectSingleElement<HTMLInputElement>(MULTILINE_TEXTAREA),
	];

	if (knitBeanieScriptLetters) {
		for (const select of knitBeanieScriptLetters) {
			select.addEventListener("click", () =>
				fontClicked({
					font: "HoodScript",
					disableBottomLetters: true,
					disableSecondaryLetters: true,
					inputElementsToReset: [...commonResetForBeanie],
					elementsToShowOrHide: [...commonElementsToShowOrHideForKnitBeanie],
				}),
			);
		}
	}

	if (knitBeanieBlockLetters) {
		for (const select of knitBeanieBlockLetters) {
			select.addEventListener("click", () =>
				fontClicked({
					font: "Hood-blockletters",
					disableBottomLetters: true,
					disableSecondaryLetters: true,
					inputElementsToReset: [...commonResetForBeanie],
					elementsToShowOrHide: [...commonElementsToShowOrHideForKnitBeanie],
				}),
			);
		}
	}

	if (knitBeanieBubbleLetters) {
		for (const select of knitBeanieBubbleLetters) {
			select.addEventListener("click", () =>
				fontClicked({
					font: "Coopernouveau",
					disableBottomLetters: true,
					disableSecondaryLetters: true,
					inputElementsToReset: [...commonResetForBeanie],
					elementsToShowOrHide: [...commonElementsToShowOrHideForKnitBeanie],
				}),
			);
		}
	}

	if (knitBeanieFormosaLetters) {
		for (const select of knitBeanieFormosaLetters) {
			select.addEventListener("click", () =>
				fontClicked({
					font: "Chinesetakeaway",
					disableBottomLetters: true,
					disableSecondaryLetters: true,
					inputElementsToReset: [...commonResetForBeanie],
					elementsToShowOrHide: [...commonElementsToShowOrHideForKnitBeanie],
				}),
			);
		}
	}

	if (knitBeanieJourneyLetters) {
		for (const select of knitBeanieJourneyLetters) {
			select.addEventListener("click", () =>
				fontClicked({
					font: "Thistails-regular",
					disableBottomLetters: true,
					disableSecondaryLetters: true,
					inputElementsToReset: [...commonResetForBeanie],
					elementsToShowOrHide: [...commonElementsToShowOrHideForKnitBeanie],
				}),
			);
		}
	}

	if (knitBeanieOldeLetters) {
		for (const select of knitBeanieOldeLetters) {
			select.addEventListener("click", () =>
				fontClicked({
					font: "Olde-regular-new",
					disableBottomLetters: true,
					disableSecondaryLetters: true,
					inputElementsToReset: [...commonResetForBeanie],
					elementsToShowOrHide: [...commonElementsToShowOrHideForKnitBeanie],
				}),
			);
		}
	}

	/*
	 * KNIT BEANIE MICRO FONTS
	 */

	const microKnitBeanieScriptLetters = selectAllElements(MICROKNITBEANIE_SCRIPT_LETTERS_SELECTOR);
	const microKnitBeanieBlockLetters = selectAllElements(MICROKNITBEANIE_BLOCK_LETTERS_SELECTOR);
	const microKnitBeanieFormosaLetters = selectAllElements(MICROKNITBEANIE_FORMOSA_LETTERS_SELECTOR);
	const microKnitBeanieOldeLetters = selectAllElements(MICROKNITBEANIE_OLDE_LETTERS_SELECTOR);

	const commonElementsToShowOrHideForKnitBeanieMicro = [
		{
			displayValue: "flex",
			elements: [selectSingleElement(MICRO_BEANIE_TEXT)],
			show: true,
		},
		{
			elements: [
				selectSingleElement(SCRIPT_TEXT),
				selectSingleElement(MULTILINE_TEXT),
				selectSingleElement(OUTLINE_TEXT),
				selectSingleElement(OUTLINE_WRAPPER_SELECTOR),
			],
			show: false,
		},
	];

	const commonResetForBeanieMicro = [
		selectSingleElement<HTMLInputElement>(SCRIPT_TEXT_INPUT),
		selectSingleElement<HTMLInputElement>(MICROSCRIPT_TEXT_INPUT),
		selectSingleElement<HTMLInputElement>(MULTILINE_TEXTAREA),
	];

	if (microKnitBeanieScriptLetters) {
		for (const select of microKnitBeanieScriptLetters) {
			select.addEventListener("click", () =>
				fontClicked({
					font: "HoodScript",
					disableBottomLetters: true,
					disableSecondaryLetters: true,
					inputElementsToReset: [...commonResetForBeanieMicro],
					elementsToShowOrHide: [...commonElementsToShowOrHideForKnitBeanieMicro],
				}),
			);
		}
	}

	if (microKnitBeanieBlockLetters) {
		for (const select of microKnitBeanieBlockLetters) {
			select.addEventListener("click", () =>
				fontClicked({
					font: "Hood-blockletters",
					disableBottomLetters: true,
					disableSecondaryLetters: true,
					inputElementsToReset: [...commonResetForBeanieMicro],
					elementsToShowOrHide: [...commonElementsToShowOrHideForKnitBeanieMicro],
				}),
			);
		}
	}

	if (microKnitBeanieFormosaLetters) {
		for (const select of microKnitBeanieFormosaLetters) {
			select.addEventListener("click", () =>
				fontClicked({
					font: "Chinesetakeaway",
					disableBottomLetters: true,
					disableSecondaryLetters: true,
					inputElementsToReset: [...commonResetForBeanieMicro],
					elementsToShowOrHide: [...commonElementsToShowOrHideForKnitBeanieMicro],
				}),
			);
		}
	}

	if (microKnitBeanieOldeLetters) {
		for (const select of microKnitBeanieOldeLetters) {
			select.addEventListener("click", () =>
				fontClicked({
					font: "Olde-regular-new",
					disableBottomLetters: true,
					disableSecondaryLetters: true,
					inputElementsToReset: [...commonResetForBeanieMicro],
					elementsToShowOrHide: [...commonElementsToShowOrHideForKnitBeanieMicro],
				}),
			);
		}
	}
}

export default fontScriptSelectSetup;
